import React, {Component} from "react";
import Avatar from '@material-ui/core/Avatar';

const styles = {
    avatar: {
        margin: 5,
        width: 20,
        height: 20,
    },
    bigAvatar: {
        margin: 10,
        width: 60,
        height: 60,
    },
};


export default class TollRenderer extends Component {
    // Read props.value directly so ag-grid cell reuse (sort/scroll/row refresh)
    // can't leave a stale flag from a previously rendered row.
    render() {
        return (
            <div>
                {this.props.value === "1" && (<Avatar alt="Toll" src="/img/toll_use.png" style={styles.avatar} />)}
            </div>
        );
    }
};

